import { memo } from 'react';
import { Union } from 'ts-toolbelt';

import { NBSP } from '~/common/constants';
import { isString } from '~/util/string';

export interface MultilineProps {
  children?: Union.Nullable<string>;
}

export const Multiline = memo(({ children }: MultilineProps) => {
  if (!children) return null;

  let content = children as any;
  if (isString(children)) content = children.split('\n');

  return content.map((item: any, key: number) => (
    <span key={key}>
      {item || NBSP}
      <br />
    </span>
  ));
});
